import { Component, Inject } from '@angular/core';
import { LatLng, TileLayer, Marker } from 'leaflet';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.awesome-markers';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ISerie } from 'src/app/shared/models/seriesInfo.interfaces';

@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.scss'],
})
export class MapDialogComponent {
  map;
  markers: any;

  Satellite: string =
    'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
  satelliteLayer = new TileLayer(this.Satellite, {
    zIndex: 1,
    maxZoom: 21,
    attribution:
      'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
  });

  osmLayer = new TileLayer(
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    { zIndex: 1, maxZoom: 21, attribution: '...' }
  );

  options = {
    maxZoom: 19,
    minZoom: 2,
    fullscreenControl: true,
    layers: [this.satelliteLayer],
  };

  zoom: number = 7;
  center: L.LatLng = new LatLng(40.650097, -8.753211);

  layersControl = {
    // overlays: {
    // },
    baseLayers: {
      'Open Street Map': this.osmLayer,
      Satellite: this.satelliteLayer,
    },
  };

  allData: ISerie[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.allData = data.allData;
  }

  onMapReady(map) {
    this.map = map;
    this.markers = L.markerClusterGroup();

    var listOfCoordinates: ISerie[] = [];
    this.allData
      .filter(d => d.locationCoords)    // Filter the series that have location coordinates
      .forEach(d => {                   // Aggregate the location coordinates
        let coordinate = listOfCoordinates
          .find(c => c.locationCoords.lat === d.locationCoords.lat && c.locationCoords.lng === d.locationCoords.lng);
        
        if (!coordinate) listOfCoordinates.push(d);
      });

    this.setMarker(listOfCoordinates);
    this.map.addLayer(this.markers);
    this.map.flyToBounds(this.markers.getBounds(), { maxZoom: 14 });
  }

  public setMarker(data: ISerie[]) {
    var stringParameters = '';
    data.forEach((element) => {
      if (element.parameterName !== 'Meteo Icons')
        stringParameters += element.description + '</br>';
    });

    var customPopup = `<div style="font-weight: \'bold\'; font-size: 19px; text-align: end">${data[0].locationName}</div>${stringParameters}`;
    var customOptions = { maxWidth: 500 };

    // https://stackoverflow.com/questions/55898409/leaflet-js-dynamic-generated-popup-html-loads-partially-if-previously-opened-p

    var layer = new Marker(data[0].locationCoords, {
      icon: L.AwesomeMarkers.icon({
        icon: 'ship',
        prefix: 'fa',
        markerColor: 'lightblue',
        iconColor: 'black',
      }),
      title: data[0].locationName,
      riseOnHover: true,
    })
      .bindTooltip(data[0].locationName, {
        permanent: false,
        zoomAnimation: true,
        direction: 'top',
      })
      .bindPopup(customPopup, customOptions);
    this.markers.addLayer(layer);
  }
}
